import React from 'react'

import SurveyIntegrationContentAndImageLayout from 'components/SurveyIntegrationContentAndImageLayout'
import ActivateIntegrationButtonSection from 'components/ActivateIntegrationButtonSection'

/**
 *
 * @param {object} props
 * @param {(IntegrationSetting) => void} props.onChange
 * @param {boolean} props.loading
 * @param {boolean} props.isAuthenticated
 * @param {boolean} props.isIntegrationActive
 */
export default function UpdateConversationAndPrivateNoteIntegration({
  onChange,
  loading,
  isAuthenticated,
  isIntegrationActive,
}) {
  function activateIntegration() {
    onChange({
      name: 'push_ticket_note',
      isActive: true,
    })
  }

  function deactivateIntegration() {
    onChange({
      name: 'push_ticket_note',
      isActive: false,
    })
  }

  return (
    <SurveyIntegrationContentAndImageLayout
      imageUrl="https://cdn.simplesat.io/intercom/add-notes-to-rated-conversations.png"
      imageDescription="Add notes to rated conversations"
    >
      <div className="mb-4">
        <p>
          Updates conversations with a private note containing rating details and any additional
          answers.
        </p>
        <a
          href="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_633ad8d578"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Learn more about adding notes to rated conversations
        </a>
      </div>

      <ActivateIntegrationButtonSection
        activateIntegration={activateIntegration}
        deactivateIntegration={deactivateIntegration}
        loading={loading}
        isAuthenticated={isAuthenticated}
        isIntegrationActive={isIntegrationActive}
        integrationType="Intercom"
      />
    </SurveyIntegrationContentAndImageLayout>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomInAppPublish/UpdateConversationAndPrivateNoteIntegration.js